export default {
  not_started: 'Stel je uitbetalingsaccount in — je omzetdeel wordt vastgehouden totdat het is geverifieerd.',
  bank_account_missing:
    'Voeg een bankrekening toe voor uitbetalingen — je omzetdeel wordt vastgehouden totdat je dit doet.',
  incomplete:
    'Je uitbetalingsaccount is nog niet volledig geverifieerd — je omzetdeel wordt vastgehouden totdat dit wel zo is.',
  add_bank_account: 'Bankrekening toevoegen',
  cta: 'Instellen voltooien',
};
